import React, { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap"

class BreadcrumbsCustom extends Component {
  render() {
    return (
      <React.Fragment>
        <Row>
          <Col xs="12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-0 font-size-18">{this.props.breadcrumbItem}</h4>
              {
                this.props.description && <small className="mb-0 float-left">{this.props.description}</small>
              }
              <div className="page-title-right">

              </div>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

BreadcrumbsCustom.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string
}

export default BreadcrumbsCustom
